import { z } from "zod";

const storageKey = "liveavatar.learner-session";
const CredentialsSchema = z.object({
  id: z.string().uuid(),
  token: z.string().min(1),
  expiresAt: z.number().positive(),
});
export type LearnerCredentials = z.infer<typeof CredentialsSchema>;

export function readSession(): LearnerCredentials | null {
  const saved = sessionStorage.getItem(storageKey);
  if (!saved) return null;
  try {
    const value: unknown = JSON.parse(saved);
    const parsed = CredentialsSchema.safeParse(value);
    if (parsed.success && parsed.data.expiresAt > Date.now()) return parsed.data;
  } catch (cause) {
    if (!(cause instanceof SyntaxError)) throw cause;
  }
  sessionStorage.removeItem(storageKey);
  return null;
}

export function rememberSession(credentials: LearnerCredentials | null) {
  if (credentials) sessionStorage.setItem(storageKey, JSON.stringify(credentials));
  else sessionStorage.removeItem(storageKey);
}
